// extracted by mini-css-extract-plugin
export default {"nav-options":"navOptions_nav-options__RzJcP","option":"navOptions_option__qt3iN","active-option":"navOptions_active-option__bdS63","donate":"navOptions_donate__R2ZrS"};